"use strict";
/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-12-6.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelEngine = void 0;
const gsap_1 = require("gsap");
const BasicEngine_1 = require("./BasicEngine");
const Helper_1 = require("../../../utils/Helper");
const GameSetting_1 = require("../../../setting/GameSetting");
const MathHelper_1 = require("../../../utils/MathHelper");
class ReelEngine extends BasicEngine_1.BasicEngine {
    constructor(callbacks, config, target) {
        super(callbacks);
        this.setConfig(config);
        this._animateContainer = target;
    }
    Start() {
        this.nextTimeline = Helper_1.Helper.timeLineNuller(this.nextTimeline);
        this.nextTimeline = new gsap_1.TimelineMax({ paused: true });
        this.nextTimeline.add(() => this.callbacks.onStartCallBack());
        this.nextTimeline.fromTo(this, GameSetting_1.GameSetting.isFastSpin ? this.configDuration.QUICK_START : this.configDuration.START, { yPos: 0 }, {
            ease: GameSetting_1.GameSetting.isFastSpin ? this.configEase.QUICK_START : this.configEase.START,
            yPos: this.reverse ? -this.defaultStep : this.defaultStep
        });
        // Correction Step
        if (this.defaultStep != Math.abs(this.stepDistance)) {
            let corrDistance = this.defaultStep - (this.defaultStep - Math.abs(this.stepDistance));
            let timescale = Math.abs(corrDistance / this.defaultStep);
            let duration = this.configDuration.SPIN * timescale;
            this.nextTimeline.fromTo(this, duration, { yPos: 0 }, {
                ease: gsap_1.Linear.easeNone,
                yPos: this.reverse ? -corrDistance : corrDistance,
            });
        }
        this.nextTimeline.add(() => this.callbacks.onCompletedStartCallback());
        return this.nextTimeline;
    }
    Step() {
        this.duration = this.configDuration.SPIN;
        this.nextTimeline = new gsap_1.TimelineMax({
            paused: true,
            onRepeat: () => this.callbacks.onCompletedStepCallback(),
            repeat: -1,
            repeatDelay: 0,
        });
        this.nextTimeline.fromTo(this, this.configDuration.SPIN, { yPos: 0 }, {
            ease: gsap_1.Linear.easeNone,
            yPos: this.stepDistance,
        });
        return this.nextTimeline;
    }
    Stop(quickStop) {
        const stopTl = new gsap_1.TimelineMax({
            paused: true,
            onComplete: () => this.onSpinStopCompleted()
        });
        this.duration = this.configDuration.SPIN;
        for (var i = 0; i < this.Steps; i++) {
            stopTl.fromTo(this, this.duration, { yPos: 0 }, {
                ease: gsap_1.Linear.easeNone,
                yPos: this.stepDistance,
            });
            stopTl.add(() => this.callbacks.onCompletedStepCallback());
        }
        this.duration = quickStop ? this.configDuration.QUICK_STOP : this.configDuration.STOP;
        let ease = quickStop ? this.configEase.QUICK_STOP : this.configEase.STOP;
        stopTl.add(() => this.callbacks.onStopCallback());
        stopTl.fromTo(this, this.duration, { yPos: 0 }, {
            ease: ease,
            yPos: this.stepDistance,
        });
        stopTl.add(() => this.onBounce(), "-=" + (this.duration * 0.8));
        // Remove if we have created an normal stop first.
        this.nextTimeline = stopTl;
        return this.nextTimeline;
    }
    Attention() {
        let tweenDuration = 1;
        var _frameFraction = 0;
        const attTl = new gsap_1.TimelineMax({
            paused: true,
            repeat: -1,
            repeatDelay: 0,
        });
        attTl.to(this, tweenDuration, {
            onStart: () => { _frameFraction = 0; },
            onUpdate: () => {
                while (attTl.progress() > _frameFraction) {
                    _frameFraction += MathHelper_1.MathHelper.frameToSeconds(0.5);
                    this.yPos += 0.2;
                    this.yPos = this.yPos % this.stepDistance;
                }
            }
        });
        // Remove if we have created an normal stop first.
        this.nextTimeline = attTl;
        return this.nextTimeline;
    }
    Idle() {
        this.nextTimeline = new gsap_1.TimelineMax();
        return this.nextTimeline;
    }
    onBounce() {
        this.callbacks.onBounceStartCallback();
    }
    onSpinStopCompleted() {
        this.yPos = 0;
        this.callbacks.onCompletedStopCallback();
    }
    onNudgeCompleted() {
        this.yPos = 0;
        this._steps--;
        this.callbacks.onCompletedNudgeCallback();
    }
    Nudge() {
        this.duration = (this.configDuration.NUDGE ? this.configDuration.START : this.configDuration.NUDGE);
        this.nextTimeline = new gsap_1.TimelineMax({
            paused: true,
            onComplete: () => this.onNudgeCompleted()
        });
        this.nextTimeline.fromTo(this, this.duration, { yPos: 0 }, {
            ease: this.configEase.NUDGE ? this.configEase.NUDGE : this.configEase.START,
            yPos: this.stepDistance,
        });
        return this.nextTimeline;
    }
}
exports.ReelEngine = ReelEngine;
//# sourceMappingURL=ReelEngine.js.map